import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import SmsCodeInput from '@src/components/sms-code-input';
import TinyInput from '@src/components/tiny-input';
import LoadingIcon from '@src/components/loading-icon';
import { PRIVACY_POLICY_URL } from '@src/constants/urls';
import Store from './store';
import Layout from '../layout';
import xauCss from '@src/components/xfe-animation-css';

const styles = require('./index.less');

const BookModal = ({ store, onClose }) => {
  store.use();
  const { $globalStore } = store;
  if (onClose) {
    store.onClose = onClose;
  }

  const renderPhoneBook = () => {
    return (
      <div className={cx(styles.phoneBook, { ...xauCss.AOS_FADE.IN_DOWN.FAST_DELAY(1) })}>
        <p className={cx(styles.txt)}>{'[手机号预约]'}</p>
        <div className={cx(styles.phone, { [styles.isError]: store.phoneInputError })}>
          <TinyInput placeholder="手机号" store={store.phoneInputStore} maxLength={11} onFocus={() => store.clearPhoneInputError()} />
          {store.phoneInputError && <div className={styles.errorInfo}>{store.phoneInputError}</div>}
        </div>
        <div className={cx(styles.code, { [styles.isError]: store.smsInputError })}>
          <TinyInput placeholder="验证码" store={store.smsInputStore} onFocus={() => store.clearSmsInputError()} />
          {!store.smsInputError && (
            <div className={styles.btnGetCodeContainer}>
              <SmsCodeInput
                phone={store.phoneInputStore.value}
                buttonText={'[获取验证码]'}
                sendCode={() => {
                  return store.onSendVCRequest();
                }}
                codeBtnClassName={styles.btnGetCode}
                btnClassName={cx(styles.btnGetCodeInner, { [store.isAgain]: !!store.countdown })}
              />
            </div>
          )}
          {store.smsInputError && <div className={styles.errorInfo}>{store.smsInputError}</div>}
        </div>
        <div className={cx(styles.agree)}>
          <div onClick={store.clickProtocol} className={cx(styles.btnAgree, { [styles.isChecked]: store.protocolCheckState })} />
          同意使用
          <Link className={styles.protocolLink} href={PRIVACY_POLICY_URL} target={'_blank'}>
            《解限机隐私保护政策》
          </Link>
        </div>
        <div className="modal-group-13" data-name="登录按钮">
          <React.Fragment>
            {!store.submitLock && (
              <Link
                className={cx('modal-group-14-text')}
                data-name="预约按钮"
                onClick={() => {
                  store.onExecuteAppointment();
                }}
              >
                {$globalStore.isSubscribeHasGift ? '预约有礼' : '立即预约'}
              </Link>
            )}
            <div className={cx(styles.loadingContainer, store.submitLock && styles.showLoading)}>
              <LoadingIcon />
            </div>
          </React.Fragment>
        </div>
      </div>
    );
  };

  // 扫码预约
  const renderScanBook = () => {
    return (
      <div className={cx(styles.scanCodeBook, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}>
        <p className={cx(styles.txt)}>{'[ 扫码添加私域预约，获取最新情报！]'}</p>
        <div className={styles.qrcodeBox}>{store.qrcodeSrc && <img className={cx(styles.qrcode)} src={store.qrcodeSrc} alt="预约二维码" />}</div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Layout className={cx(styles.bookModalRoot)} isOpen={store.isOpen} onClose={store.onClickClose}>
        <div className={cx(styles.content, store.isOpen && xauCss.AOS_ROOT)}>
          {renderScanBook()}
          {renderPhoneBook()}
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default wrapStore(BookModal, Store);
